import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from './Button';
const scrollTo = (id: string) => (e: React.MouseEvent) => {
  e.preventDefault();
  document.getElementById(id)?.scrollIntoView({
    behavior: 'smooth'
  });
};
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-48 md:pb-28 overflow-hidden bg-grid-schematic" data-id="element-42">
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-transparent via-transparent to-background" aria-hidden="true" data-id="element-43" />
      <div className="container relative" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="max-w-4xl" data-id="element-45">
          <div className="flex items-center gap-2 mb-6" data-id="element-46">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-signal animate-signal-pulse" aria-hidden="true" data-id="element-47" />
            <p className="font-mono text-xs font-medium text-muted-foreground tracking-[0.2em] uppercase" data-id="element-48">
              AI systems, built on-site
            </p>
          </div>
          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl font-medium tracking-tight text-foreground leading-[1.05]" data-id="element-49">
            Most AI pilots never leave the deck.
            <br data-id="element-50" />
            <span className="text-muted-foreground" data-id="element-51">Ours ship.</span>
          </h1>
          <p className="mt-8 text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed" data-id="element-52">
            We're a small team of engineers who sit with yours — in your office,
            in your codebase, on your data. No strategy phase, no discovery
            theatre. We start building in week one, and six weeks later there's
            a system running in production, carrying real work, with your team
            trained to keep it running.
          </p>
          <p className="mt-4 text-lg md:text-xl text-foreground max-w-2xl leading-relaxed font-medium" data-id="element-53">
            If you've got a process bleeding hours every week, the fastest way
            to find out what AI can do about it is a thirty-minute conversation.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-54">
            <Button size="lg" onClick={scrollTo('start-engagement')} className="group rounded-none font-mono text-xs uppercase tracking-widest" data-id="element-55">
              Book a 30-minute call
              <ArrowRight className="ml-1.5 h-4 w-4 transition-transform group-hover:translate-x-0.5" data-id="element-56" />
            </Button>
            <Button size="lg" variant="outline" onClick={scrollTo('how-we-engage')} className="rounded-none font-mono text-xs uppercase tracking-widest border-border" data-id="element-57">
              How we engage
            </Button>
          </div>
        </motion.div>
      </div>
      <div className="absolute -bottom-1 left-0 right-0 h-px bg-border" data-id="element-58" />
    </section>;
}